import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import CreateSaq from "../../components/CreateSaq";

import { images } from "../../helpers/images";
import { onClickBusinessSignup } from "../../modules/actions";

import {
  callApiSaqsFind,
  callApiUsersList,
  callApiBusinessesList,
  callApiWhiteLabelBusinessesList,
  callApiGetBusinessIdUsingSubdomain,
} from "../../services";
import { authUserData } from "../../helpers";
import SaqLists from "../../components/SaqLists";
import Header from "../../components/Header";
import BusinessAdminHeader from "../../components/BusinessAdminHeader";

class CreateUser extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      purpose: "white-label-user-signup",
      email: "",
      password: "",
      confirmPassword: "",
      secretCode: process.env.REACT_APP_WHITE_LABEL_AND_BUSINESS_ADMIN_SECRET,
      disableLogin: false,
      website: "",
      subdomain: "",
      userData: null,
    };
  }

  componentDidMount = async () => {
    const hostname = window.location.hostname;

    // Split by dots
    const parts = hostname.split(".");

    // Get the subdomain (first part)
    const subdomain = parts[0];

    const userData = authUserData();

    this.setState({ subdomain, userData: userData });

    // const businessInfo = await callApiGetBusinessIdUsingSubdomain(subdomain);

    /* console.log(
      businessInfo?.data?.length > 0
        ? businessInfo.data[0]
          ? businessInfo.data[0]._id
          : null
        : null,
      "businessInfo"
    ); */

    /* this.setState({
      businessId:
        businessInfo?.data?.length > 0
          ? businessInfo.data[0]
            ? businessInfo.data[0]._id
            : null
          : null,
      businessName:
        businessInfo?.data?.length > 0
          ? businessInfo.data[0]
            ? businessInfo.data[0].businessName
            : null
          : null,
    }); */
  };

  onChangeHandelUserInput = async (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;

    this.setState({
      [name]: value,
    });
  };

  onClickSignup = async () => {
    this.setState({ disableLogin: true });
    const businessSignupPayload = {
      purpose: this.state.purpose,
      userType: this.state.userType,
      businessId: this.state.businessId,
      businessName: this.state.businessName,
      email: this.state.email,
      password: this.state.password,
      confirmPassword: this.state.confirmPassword,
      secretCode: this.state.secretCode,
      subdomain: this.state.subdomain,
    };
    console.log("businessSignupPayload", businessSignupPayload);

    const status = await this.props.onClickBusinessSignup(
      businessSignupPayload
    );

    console.log("status", status);

    if (status === true) {
      setTimeout(
        () =>
          this.setState({
            purpose: "",
            email: "",
            password: "",
            confirmPassword: "",
            subdomain: "",
            secretCode: "",
            disableLogin: false,
          }),
        2500
      );
    } else {
      this.setState({
        disableLogin: false,
      });
    }
  };

  onTextKeyPress = (evt) => {
    if (evt.key === "Enter") {
      this.onClickSignin(evt);
    }
  };

  render() {
    const { history } = this.props;
    const {
      userData,
      purpose,
      email,
      password,
      confirmPassword,
      secretCode,
      disableLogin,
      businessSourceId,
    } = this.state;

    return (
      <>
        <ToastContainer />
        <div className="cell small-12 medium-10" id="maincontent">
          {userData && !userData.isAdmin && <BusinessAdminHeader />}
          <div id="body-content">
            <div className="grid-x grid-margin-x grid-margin-y">
              <div className="cell small-12 medium-12" id="completedsaqs">
                <div className="module-header">
                  <h3>Create User</h3>
                  <Link to="/control-panel/users">
                    <button className="button nxt-btn">Company Users</button>
                  </Link>
                </div>
                <div id="compltedsaqs-table">
                  <div className="grid-container">
                    <div className="grid-x grid-margin-x align-center">
                      <div className="small-12 medium-8 cell">
                        <label>Email</label>
                        <input
                          type="email"
                          placeholder="Enter email"
                          name="email"
                          value={email}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </div>
                      <div className="small-12 medium-8 cell">
                        <label>Password</label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Enter password"
                          name="password"
                          value={password}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </div>

                      <div className="small-12 medium-8 cell">
                        <label>Confirm Password</label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Enter confirm password"
                          name="confirmPassword"
                          value={confirmPassword}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </div>

                      {/* <div className="small-12 medium-8 cell">
                        <label>Business Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter business name"
                          name="businessName"
                          value={businessName}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </div>

                      <div className="small-12 medium-8 cell">
                        <label>Website</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter website"
                          name="website"
                          value={website}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </div> */}
                    </div>
                    <div className="grid-x grid-margin-x align-center">
                      <div
                        className="small-12 medium-8 cell"
                        style={{ textAlign: "right" }}
                      >
                        <button
                          className="button prev-btn"
                          onClick={() => history.push(`/control-panel/users`)}
                          disabled={disableLogin}
                          style={{ color: "#000", marginRight: "25px" }}
                        >
                          Cancel
                        </button>
                        <button
                          className="button nxt-btn"
                          onClick={() => this.onClickSignup()}
                          disabled={disableLogin}
                        >
                          Create User
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ onClickBusinessSignup }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateUser);
